import { LABEL } from '@veriables';

const KEYS = {
  SYNC_CHECK: 'syncCheck',
  REPOST_PAYMENT: 'repostPayment',
  LAUNCH_EXTERNAL_APP: 'launchExternalApp',
  ATTACH_TO_PARTY: 'attachToParty',
  TABLE: 'table',
  EMPLOYEE: 'employee',
  VOID_CHECK: 'voidCheck',
  MERGE_CHECK: 'mergecheck',
  GAME_CARD: 'gameCard',
  ADD_LOYALTY: 'addLoyalty',
  GIFT_CARD: 'giftCard',
  RECEIPT: 'receipt',
  PRINT: 'print',
};

const TOOL_BUTTONS = [
  {
    id: 1,
    key: KEYS.SYNC_CHECK,
    label: LABEL().SYNC_CHECKS_WITH_POS,
  },
  {
    id: 2,
    key: KEYS.REPOST_PAYMENT,
    label: LABEL().REPOST_PAYMENT,
  },
  {
    id: 3,
    key: KEYS.TABLE,
    label: LABEL().TRANSFER_TABLE,
      // label: LABEL().TRANSFER_TAB 
  },
  {
    id: 4,
    key: KEYS.LAUNCH_EXTERNAL_APP,
    label: '',
  },
  {
    id: 13,
    key: KEYS.ATTACH_TO_PARTY,
    label: LABEL().ATP_ATTACH_TO_PARTY
  },
  {
    id: 5,
    key: KEYS.EMPLOYEE,
    label: LABEL().TRANSFER_EMPLOYEE,
  },
  {
    id: 6,
    key: KEYS.VOID_CHECK,
    label: LABEL().VOID_CHECK,
  },
  {
    id: 7,
    key: KEYS.MERGE_CHECK,
    label: LABEL().MERGE_CHECK,
  },
  {
    id: 8,
    key: KEYS.GAME_CARD,
    label: LABEL().GAME_CARDS,
  },
  {
    id: 9,
    key: KEYS.ADD_LOYALTY,
    label: LABEL().ADD_LOYALTY,
  },
  {
    id: 10,
    key: KEYS.GIFT_CARD,
    label: LABEL().GIFT_CARDS,
  },
  {
    id: 11,
    key: KEYS.RECEIPT,
    label: LABEL().RECEIPT,
  },
  {
    id: 12,
    key: KEYS.PRINT,
    label: LABEL().PRINT,
  },
];

export { TOOL_BUTTONS, KEYS };
